import React from "react"
import CustomPageHeader from "../../fragments/CustomPageHeader"

export default function ExtraAccounting({ children }) {
  return (
    <div>
      <CustomPageHeader icon='cube' text='Extra loan accounting' />
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Accounting/ExtraAccounting/index.js